export default __webpack_public_path__ + "static/media/widget-bg-3.71e69194.png";